/**
 * getInstalledRelatedApps API is in experimental phase, so types are not yet standardized.
 */
export interface NavigatorLatest extends Navigator {
    getInstalledRelatedApps?: () => Promise<InstalledRelatedApp[]>;
}

interface InstalledRelatedApp {
    platform: string;
    id?: string;
    url?: string;
    version?: string;
}

const WEB_APP = 'webapp';

/**
 * Tells whether the outlook PWA is already installed in user's device.
 * This capability is provided by the PWA manifest file and 'getInstalledRelatedApps' API.
 * NOTE:
 *      We are only detecting PWA installed in scope. Which means if PWA for 'outlook.live.com' is installed,
 * then we can only detect it from same url web app i.e, 'outlook.live.com' and not otherwise (like 'outlook-sdf.live.com').
 * To learn more, refer: https://web.dev/get-installed-related-apps/#check-pwa-in-scope
 */
export const isPWAInstalled = async (): Promise<boolean> => {
    if (!isGetInstalledRelatedAppsAPISupported(navigator)) {
        return false;
    }

    const installedRelatedApps = await navigator.getInstalledRelatedApps();
    return !!installedRelatedApps.find(isWebApp);
};

const isGetInstalledRelatedAppsAPISupported = (
    navigator: Navigator
): navigator is NavigatorLatest => 'getInstalledRelatedApps' in navigator;

const isWebApp = (app: InstalledRelatedApp) => app.platform === WEB_APP;
